import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Sponsor } from '../schema/sponsor';
import { HttpService } from 'src/app/core/data/service/http.service';

@Injectable({
  providedIn: 'root'
})
export class SponsorService extends HttpService {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = `${this.apiURL}/sponsors`;
  }

  async saveSponsorSortOrder(sponsors: Sponsor[]) {
    // loop through sponsors and set the sort order
    sponsors.forEach((sponsor, index) => {
      sponsor.sortOrder = index + 1;
    });
    return super.put(sponsors, `${this.endpoint}/sortorder`);
  }

  async fetchSponsorById(sponsorId: number) {
    return new Sponsor(await super.fetch(`${this.endpoint}/${sponsorId}`));
  }

  async fetchTiersByAucId(auctionId: number) {
    return await super.fetch(`${this.endpoint}/tiers/${auctionId}`) as string[];
  }
  
  deleteSponsor(sponsorId: number) {
    return this.deleteItem(sponsorId, `${this.endpoint}`);
  }

  deleteLogo(sponsorId: number) {
    return this.delete(`${this.endpoint}/${sponsorId}/logo`);
  }

  protected isUpdate(entity: Sponsor) {
    return (entity.sponsorId != null);
  }

  protected getUpdateUrl(entity: Sponsor, endpoint: string = this.endpoint) {
    return `${endpoint}/${entity.sponsorId}`;
  }
}
